// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CustomWidget: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M29.743 0H4.198C1.906 0 0 2.174 0 4.857v24.286C0 31.826 1.906 34 4.198 34h25.545C32.094 34 34 31.826 34 29.143V4.857C34 2.174 32.151 0 29.743 0Zm2.132 29.396c0 1.366-.954 2.479-2.125 2.479H4.25c-1.171 0-2.125-1.113-2.125-2.48V4.606c0-1.367.954-2.48 2.125-2.48h25.5c1.171 0 2.125 1.113 2.125 2.48v24.79Zm-10.3-17.855c-.755-1.154-2.649-1.15-3.402-.004l-4.859 7.356-1.089-1.501c-.757-1.116-2.536-1.063-3.3 0l-4.285 5.92a2.046 2.046 0 0 0-.169 2.126 2.022 2.022 0 0 0 1.821 1.124h21.416c.758 0 1.448-.417 1.802-1.087a2.053 2.053 0 0 0-.1-2.096l-7.835-11.838ZM6.362 24.437l4.143-5.802 1.986 2.745c.206.282.551.48.883.441.349-.008.672-.185.865-.477l5.567-8.626 7.753 11.72H6.362Zm3.2-10.625a3.188 3.188 0 1 0-.001-6.376 3.188 3.188 0 0 0 .001 6.376Zm0-4.25c.586 0 1.003.477 1.003 1.063s-.418 1.062-1.003 1.062A1.066 1.066 0 0 1 8.5 10.625c0-.584.478-1.063 1.062-1.063Z"
            />
        </svg>
    );
};

export default React.memo(CustomWidget);
